export const environment = {
    apiURL: "https://wzg8n1lbee.execute-api.us-east-1.amazonaws.com/prod",
    captchaSiteKey: '6LfBK-AkAAAAAE1WRRtpCoACqVDs8ZT_Ta12wbBB'
};
